<template>
  <div>
    <div class="d-flex" id="wrapper">
      <!-- Sidebar -->
      <SideBar/>
      <!-- /#sidebar-wrapper -->
      <!-- Page Content -->
      <div id="page-content-wrapper">
        <nav style="justify-content:flex-start;" class="navbar navbar-expand-lg navbar-light bg-light border-bottom floating">
          <div>
            <button class="btn btn-outline" id="menu-toggle" @click="sidebar"><span class="navbar-toggler-icon"></span>
            </button>

            <button style="color: rgba(0,0,0,.5);border-color: rgba(0,0,0,.1);" class="btn btn-outline navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span style="padding-top:0.5em;"><i class="fas fa-user-alt"></i><span class="account-div"></span><i class="fas fa-angle-down"></i></span>
            </button>
          </div>
          <div class="d-flex">
            <p class="text-muted mb-0 hover-cursor">&nbsp;Invoicing /&nbsp;</p>
            <p class="text-primary mb-0 hover-cursor">Payments</p>
          </div>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto mt-2 mt-lg-0">
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                  {{ admin }}
                </a>
                <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                  <a class="dropdown-item link" @click="toPage('/password')"> <i class="fas fa-cog"></i><span class="right-dropdown">Change Password</span></a>
                  <a class="dropdown-item link" @click="handleLogout"><i class="fas fa-sign-out-alt"></i><span class="right-dropdown">Logout</span></a>
                </div>
              </li>
            </ul>
          </div>
        </nav>
        <div class="container-fluid">
          <div class="row">
            <div class="col-md-12 grid-margin stretch-card card-div">
              <div class="container">
                <br>
                <div class="search-table container-fluid">
                  <div class="row align-items-end">
                      <div class="col-lg-3 col-sm mobile-div">
                          <label class="input-label">Company Name/Order ID</label> 
                          <input v-model="companyNameOrOrderIdValue" type="text" class="form-control">
                      </div>
                      <div class="col-lg-3 col-sm mobile-div">
                          <label class="input-label">Status</label> 
                          <multiselect 
                            v-model="statusValue" 
                            :options="statusOptions"
                            track-by="value"
                            label="label"
                            :close-on-select="true"
                            :selectLabel="''"
                            :deselectLabel="''"
                          >
                          </multiselect>
                      </div>
                      <div class="col-lg-2 col-sm mobile-div">
                          <button class="btn btn-primary mt-4" @click="searchData"> Search </button>
                      </div>
                  </div>
                </div>
                <br>
                <table class="table table-sm table-bordered table-striped table-responsive-sm">
                  <thead class="">
                    <tr>
                      <th>RPID</th>
                      <th>Customer Name</th>
                      <th>Payment to</th>
                      <th>Total</th>
                      <th>Created</th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- <tr v-if="loadingTable === false && totalData == 0">
                      <td colspan="7" class="text-center">Data Not Available</td>
                    </tr>
                    <tr v-else-if="loadingTable === true">
                      <td colspan="7" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr> -->
                    <tr >
                      <td><router-link class="link" :to="`/invoicing/payments/RP123?cust=PT Eden Pangan Indonesia&custId=123`" >RP123</router-link></td>
                      <td>PT Eden Pangan Indonesia</td>
                      <td>ID123, ID234</td>
                      <td>Rp 310.000.000</td>
                      <td>By Atika, 23 September 2023</td>
                    </tr>
                  </tbody>
                </table>
                <div id="wrapperr">
                  <div id="c1">
                    <div class="alignLeft total-data">
                      Total Data {{ totalData }} 
                    </div>
                  </div>
                  <div id="c2">
                    <div class="pagination p8 alignRight">
                      <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>></li></a>
                      </ul>
                    </div>
                  </div>
                </div>​
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /#page-content-wrapper -->
    </div>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import SideBar from '../SideBar'
export default {
  name: 'ResolutionCenterPage',
  components:{
    SideBar,
    Multiselect
  },
  data () {
    return {
      // =====================================================
      companyNameOrOrderIdValue:'',
      statusValue:null,
      statusOptions: [
        {
          label:'All',
          value:'All',
        },
        {
          label:'Open',
          value:'open',
        },
        {
          label:'Paid',
          value:'paid',
        },
        {
          label:'Partially Paid',
          value:'partially_paid',
        },
        {
          label:'Overpaid',
          value:'overpaid',
        },
      ],

      // =====================================================
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      viewInvoicing : false,
      viewPaymentList : false,
      totalData:0,
      totalPage:1,
      currentPage:1,
      loadingTable: true,
    }
    },
  methods: {
    toPage(e) {
      this.$router.push(e)
    },
    searchData() {
      console.log("Search Data")
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(process.env.LOGOUT, {}, {
          headers: {
            'Asani-Token': localStorage.getItem('jwt')
          }
        })
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          })
          return
        }

      } catch (error) {
        if(error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          })
          return
        }
      }
      localStorage.removeItem('jwt')
      localStorage.removeItem('admin_name')
      localStorage.removeItem('roles')
      localStorage.removeItem('user_email')
      localStorage.removeItem('admin_id')
      localStorage.removeItem('changeCatalogPermission')
      this.$router.push('/')
    },
    cekLogin(){
      if (localStorage.getItem('jwt') == null) {
        this.$router.push('/')
      }
    },
    cekPermission(){
      this.permission = localStorage.getItem('roles').replace(/"/g,"").replace("[","").replace("]","").split(",")
      for(var i=0; i < this.permission.length; i++){
        if( this.permission[i] == "1"){
          this.viewDashboard = true
        }
        if( this.permission[i] == "2.1"){
          this.viewOrder = true
        }
        if( this.permission[i] == "2.2"){
          this.editOrder = true
        }
        if( this.permission[i] == '3.1'){
          this.viewReturn = true
        }
        if( this.permission[i] == '3.2'){
          this.editReturn = true
        }
        if( this.permission[i] == '4.1'){
          this.viewProduct = true
        }
        if( this.permission[i] == '4.2'){
          this.editProduct = true
        }
        if( this.permission[i] == '5.1'){
          this.viewPairing = true
        }
        if( this.permission[i] == '5.2'){
          this.editPairing = true
        }
        if( this.permission[i] == '6'){
          this.viewReconcile = true
        }
        if( this.permission[i] == '7.1'){
          this.viewResolution = true
        }
        if( this.permission[i] == '7.2'){
          this.editResolution = true
        }
        if( this.permission[i] == '8.1'){
          this.viewLessor = true
        }
        if( this.permission[i] == '8.2'){
          this.editLessor = true
        }
        if( this.permission[i] == '9.1'){
          this.viewLessee = true
        }
        if( this.permission[i] == '9.2'){
          this.editLessee = true
        }
        if( this.permission[i] == '10'){
          this.viewEmployee = true
        }
         if(this.permission[i] == '21') {
          this.viewInvoicing = true
        }
        if(this.permission[i] == '21.3') {
          this.viewPaymentList = true
        }
      }
      if (this.viewPaymentList == false) {
        this.$router.push('/')
      }
    },
    sidebar(){
      $("#wrapper").toggleClass("toggled");
    },
  },
  created(){
    this.getData()
    this.admin = localStorage.getItem('admin_name')
    this.cekLogin()
    this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
$('#modalCreate').on('hidden.bs.modal', function () {
    // self.wadaw()
});
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .case-knowledge:hover{
    cursor: pointer;
    background-color: #2797FB;
    color: white;
  }

.input-label {
color: #2E3646;
font-size: 0.875rem;
font-style: normal;
font-weight: 600;
line-height: 1.25rem;
letter-spacing: -0.00088rem;
}
.key{
  width: 168px;
  margin: 7px 0px;
}
.titik2{
  margin: 7px 0px;
  padding: 0px 9px;
}
.field{
  width: 100%;
}
.one-line{
  display: flex;
  margin: 4px 0px;
}
.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

.search-table{
padding-bottom: 7px;
margin-top: -5px;
margin-left: -15px;
}
.active{
color: #2797FB;
}
.right-dropdown{
margin-left: 7px;
}
.account-div{
margin: 2px 2px;
}
.right-arrow{
margin-left: auto;
}
.brand-logo{
width: 120px;
}
.menu-title{
margin-left: 1.125rem;
}
.menu-title-order{
margin-left: 1.95rem;
}
.menu-title-payment{
margin-left: 1.525rem;
}

ul {
list-style-type: none;
margin: 0;
padding: 0;
/*width: 200px;*/
/*background-color: #f1f1f1;*/
}

li.sidebar a {
display: block;
color: #000;
padding: 8px 63px;
text-decoration: none;
}

li a.active {
background-color: #4CAF50;
color: white;
}

li a:hover:not(.active) {
background-color: #2797FB;
color: white;
}
.nav-side-menu {
overflow: auto;
font-family: verdana;
font-size: 12px;
font-weight: 200;
background-color: #2e353d;
position: fixed;
top: 0px;
width: 300px;
height: 100%;
color: #e1ffff;
}
.nav-side-menu .brand {
background-color: #23282e;
line-height: 50px;
display: block;
text-align: center;
font-size: 14px;
}
.nav-side-menu .toggle-btn {
display: none;
}
.nav-side-menu ul,
.nav-side-menu li {
list-style: none;
padding: 0px;
margin: 0px;
line-height: 35px;
cursor: pointer;
}
 .nav-side-menu ul :not(collapsed) .arrow:before,
 .nav-side-menu li :not(collapsed) .arrow:before {
  font-family: FontAwesome;
  content: "\f078";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
  float: right;
}
.nav-side-menu ul .active,
.nav-side-menu li .active {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
}
.nav-side-menu ul .sub-menu li.active,
.nav-side-menu li .sub-menu li.active {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li.active a,
.nav-side-menu li .sub-menu li.active a {
  color: #d19b3d;
}
.nav-side-menu ul .sub-menu li,
.nav-side-menu li .sub-menu li {
  background-color: #181c20;
  border: none;
  line-height: 28px;
  border-bottom: 1px solid #23282e;
  margin-left: 0px;
}
.nav-side-menu ul .sub-menu li:hover,
.nav-side-menu li .sub-menu li:hover {
  background-color: #020203;
}
.nav-side-menu ul .sub-menu li:before,
.nav-side-menu li .sub-menu li:before {
  font-family: FontAwesome;
  content: "\f105";
  display: inline-block;
  padding-left: 10px;
  padding-right: 10px;
  vertical-align: middle;
}
.nav-side-menu li {
  padding-left: 0px;
  border-left: 3px solid #2e353d;
  border-bottom: 1px solid #23282e;
}
.nav-side-menu li a {
  text-decoration: none;
  color: #e1ffff;
}
.nav-side-menu li a i {
  padding-left: 10px;
  width: 20px;
  padding-right: 20px;
}
.nav-side-menu li:hover {
  border-left: 3px solid #d19b3d;
  background-color: #4f5b69;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  -ms-transition: all 1s ease;
  transition: all 1s ease;
}
@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/InvoicePaymentListPage.vue